import { useEffect } from 'react';
import { CLOSING_REDIRECT_DELAY_MS } from '../constants/siteClosing';
import { shouldRedirectClosingSite } from '../utils/closingSiteRedirect';
import { isEmbeddedInFrame } from '../utils/isEmbeddedInFrame';

interface ClosingSiteRedirectOptions {
  delayMs?: number;
  navigate?: (url: string) => void;
}

// replace(), not assign(), so Back does not land on the closing page and restart the countdown.
const replaceCurrentPage = (url: string) => window.location.replace(url);

export function useClosingSiteRedirect(
  targetUrl: string | null,
  { delayMs = CLOSING_REDIRECT_DELAY_MS, navigate = replaceCurrentPage }: ClosingSiteRedirectOptions = {}
): void {
  useEffect(() => {
    const shouldRedirect = shouldRedirectClosingSite({
      currentHost: window.location.hostname,
      targetUrl,
      isEmbedded: isEmbeddedInFrame(),
    });
    if (!targetUrl || !shouldRedirect) {
      return;
    }

    const timerId = setTimeout(() => navigate(targetUrl), delayMs);
    return () => clearTimeout(timerId);
  }, [targetUrl, delayMs, navigate]);
}
